"use strict";

exports.__esModule = true;
exports["default"] = exports.TopImage = exports.ListLink = exports.ListItem = exports.List = exports.HtmlRelatedContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ItemBack = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "related__ItemBack",
  componentId: "sc-wnbrhj-0"
})(["position:relative;border-radius:12px;overflow:hidden;background-color:", ";box-shadow:0 4px 16px 0 ", ",0 2px 4px 0 ", ";"], function (props) {
  return props.ui === "dark" ? (0, _styles.themeTransparentize)(1, "background", props) : (0, _styles.colors)("background", props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.92, "background-dark")(props);
}, function (props) {
  return (0, _styles.themeTransparentize)(0.84, "background-dark")(props);
});

var Title = _styledComponents["default"].span.withConfig({
  displayName: "related__Title",
  componentId: "sc-wnbrhj-1"
})(["letter-spacing:0.3px;"]);

var List = _styledComponents["default"].ul.withConfig({
  displayName: "related__List",
  componentId: "sc-wnbrhj-2"
})(["list-style:none;margin:0;padding:0;"]);

exports.List = List;
var ListItem = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "related__ListItem",
  componentId: "sc-wnbrhj-3"
})(["border-top:1px solid ", ";"], function (props) {
  return (0, _styles.colors)("border", props);
});
exports.ListItem = ListItem;

var ListLink = _styledComponents["default"].a.withConfig({
  displayName: "related__ListLink",
  componentId: "sc-wnbrhj-4"
})(["text-decoration:none;color:", ";", ";opacity:1;&:hover{opacity:0.7;}"], function (_ref) {
  var colorScheme = _ref.colorScheme,
      theme = _ref.theme;
  return (0, _styles.colors)(colorScheme, {
    theme: theme
  });
}, (0, _styles.defaultTransition)(["opacity"]));

exports.ListLink = ListLink;
var TopImage = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "related__TopImage",
  componentId: "sc-wnbrhj-5"
})(["max-width:100%;height:auto;"]);
exports.TopImage = TopImage;
var titleFont = {
  color: "title-black",
  fontSize: 5,
  fontWeight: 2,
  lineHeight: 2,
  mb: 2,
  tag: "h3",
  textAlign: "left"
};
var descriptionFont = {
  color: "text",
  fontSize: 3,
  fontWeight: 1,
  lineHeight: 3,
  textAlign: "left"
};
var propTypes = {
  /** alt text for image */
  alt: _propTypes.string,

  /** position for list */
  "class": _propTypes.string,

  /** color from the color scheme */
  colorScheme: _propTypes.string,

  /** cta node */
  cta: _propTypes.node,

  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** description text */
  description: _propTypes.string,

  /** title text */
  header: _propTypes.string,

  /** link url */
  href: _propTypes.string,

  /** image src url */
  imageSrc: _propTypes.string,

  /** array of list items */
  items: (0, _propTypes.arrayOf)(_propTypes.object)
};

var HtmlRelatedContent = function HtmlRelatedContent(_ref2) {
  var alt = _ref2.alt,
      position = _ref2["class"],
      colorScheme = _ref2.colorScheme,
      cta = _ref2.cta,
      dataTestId = _ref2["data-test-id"],
      description = _ref2.description,
      header = _ref2.header,
      href = _ref2.href,
      imageSrc = _ref2.imageSrc,
      items = _ref2.items;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    "data-test-id": dataTestId,
    mx: "auto",
    my: [4, 4, 4, 0],
    pl: [0, 0, 0, 4],
    width: [1, 3 / 4, 1]
  }, /*#__PURE__*/_react["default"].createElement(ItemBack, {
    color: colorScheme,
    flexDirection: "column",
    tag: "aside"
  }, imageSrc && /*#__PURE__*/_react["default"].createElement(TopImage, {
    alt: alt,
    src: imageSrc
  }), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: "column",
    px: 2,
    py: 2
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, titleFont, /*#__PURE__*/_react["default"].createElement(Title, null, header)), items && /*#__PURE__*/_react["default"].createElement(List, {
    position: position
  }, items.map(function (_ref3) {
    var item = _ref3.item,
        ahref = _ref3.href;
    return /*#__PURE__*/_react["default"].createElement(ListItem, {
      key: item.id,
      px: 0,
      py: 2,
      tag: "li"
    }, ahref ? /*#__PURE__*/_react["default"].createElement(ListLink, {
      colorScheme: "blue",
      href: ahref
    }, item) : item);
  })), description && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, descriptionFont, description), cta && href && /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    color: colorScheme,
    glyphRight: /*#__PURE__*/_react["default"].createElement(_components.NavCaretRight, null),
    mt: 2,
    size: "small",
    url: href,
    version: "link"
  }, cta))));
};

exports.HtmlRelatedContent = HtmlRelatedContent;
HtmlRelatedContent.propTypes = propTypes;
HtmlRelatedContent.displayName = "Modules.HtmlRelatedContent";
var _default = HtmlRelatedContent;
exports["default"] = _default;